function openTab(url) {
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.rel='noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

function openTab_v2(url) {
    const link = document.createElement('a');
    link.href = `${getBaseUrl()}/${url}`;
    link.target = '_blank';
    link.rel='noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

function debounce(func, timeout = 300){
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}

function getBaseUrl() {
    return `${window.location.protocol}//${window.location.host}`;
}

module.exports = {
    openTab,
    openTab_v2,
    debounce,
    getBaseUrl
};



// WEBPACK FOOTER //
// ./src/commons/browser.js